export const handleResearchInitiativeHelper = (selectedOption) => {
  let researchInitiative = [];
  selectedOption.forEach((info) => {
    researchInitiative.push(info.label);
  });
  let updateDataQuery = {
    researchInitiative: researchInitiative.length > 0 ? researchInitiative.join(",") : "all",
  };
  return updateDataQuery;
};
